<template>
  <div id="app">
    <router-view/>
    <notifications group="success" />
    <notifications group="error" />
    <notifications group="warning" />
  </div>
</template>
<script>
export default {
  computed: {
    notifications() {
      return this.$store.state.notifications;
    }
  },
  watch: {
    notifications() {
      if (this.notifications) {
        if (this.notifications.type == "success") {
          this.$notify({
            group: "success",
            type: "success",
            title: this.notifications.title,
            text: this.notifications.message
          });
        } else if (this.notifications.type == "error") {
          this.$notify({
            group: "error",
            type: "error",
            title: this.notifications.title,
            text: this.notifications.message
          });
        }
      }
    }
  }
}
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
